import { CompanyMembersProvider } from './context/CompanyMembersProvider'
import { CompanyMembersMain } from './components/CompanyMembersMain'

export function CompanyMembers() {
  return (
    <CompanyMembersProvider>
      <CompanyMembersMain />
    </CompanyMembersProvider>
  )
}
